/* npm-add bootstrap-datepicker */

import $ from 'jquery';
import nl from '../language/nl';

// Datepicker elements
let $date = $('.js-datepicker');

const datePicker = {
  /**
   * Initialize datepicker module, first check if datepickers are found on the page
   * @return {void}
   */
  initialize() {
    if ($date.length) {
      this.loadDatepicker(() => {
        this.createPickers();

        $(document).on('reinit:datepickers', () => {
          this.createPickers();
        });
      });
    }
  },

  /**
   * Load the Bootstrap-datepicker plugin
   * @param  {function} cb - Callback for when the plugin is loaded
   * @return {void}
   */
  loadDatepicker(cb) {
    require(['bootstrap-datepicker'], () => { // eslint-disable-line
      cb.call(this);
    });
  },

  retrieveData($el, key, fallback) {
    return typeof $el.data(key) !== 'undefined' ? $el.data(key) : fallback;
  },

  strToDate(str) {
    // The data year should be in format YYYY-MM-DD
    const split = str.split('-');

    // Put it nicely in an object
    const dateObj = {
      year: parseInt(split[0], 10),
      month: parseInt(split[1], 10) - 1,
      day: parseInt(split[2], 10),
    };

    // Create Date object with the data above
    return new Date(dateObj.year, dateObj.month, dateObj.day);
  },

  /**
   * Initialize datepickers
   * @return {void}
   */
  createPickers() {
    $.fn.datepicker.dates.nl = nl.datepicker;

    $date = $('.js-datepicker');

    $date.filter(':not(.is-created)').toArray().forEach((date) => {
      const $el = $(date);
      let minDate = this.retrieveData($el, 'min-date', false);
      let endDate = this.retrieveData($el, 'end-date', false);
      const defaultDate = this.retrieveData($el, 'default-date', new Date());
      const defaultView = this.retrieveData($el, 'default-view', 0);

      if (minDate) {
        minDate = this.strToDate(minDate);
      }

      if (endDate) {
        endDate = this.strToDate(endDate);
      }

      $el.datepicker({
        format: 'dd-mm-yyyy',
        language: 'nl',
        autoclose: true,
        startDate: minDate || new Date(),
        endDate: endDate || Infinity,
        defaultViewDate: defaultDate,
        startView: defaultView,
      });

      $el.addClass('is-created');
    });
  },
};

export default datePicker;
